angular.module('omfm').directive('saoLetters', SaoLettersDirective);

SaoLettersDirective.$inject = ['$rootScope', '$timeout'];

function SaoLettersDirective($rootScope, $timeout) {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {
			type: "@"
		},
		templateUrl: "/app/omfm/templates/saoLetters.html",
		link:        function ($scope) {
			$scope.$on('sao:editLetters', function(event, data) {
				if(data.type !== $scope.type){
					return;
				}

				$timeout(function() {
					jQuery('body').addClass($scope.type + '-is-open');
				}, 0);

				let curNextIndex = $scope.nextIndex;

				$scope.letters   = data.letters;
				$scope.nextIndex = data.nextIndex;
				$scope.prevIndex = data.prevIndex;
				$scope.title     = data.title;
				$scope.url       = data.url;
				$scope.company   = data.company;
				$scope.list      = data.list || {};
				$scope.contact   = data.contact;
				$scope.saveFunc  = data.save;

				$scope.isOpen = true;

				// Next button was pressed when editor was opened
				if(curNextIndex === $scope.prevIndex + 1 && $scope.domainIsOpen) {
					$scope.openUrl();
				}

				if($scope.company && $scope.company.id !== 0) {
					$scope.openContacts();
				}
			});

			$scope.$on('sao:closeLettersEditor', function(event, data){
				if(data.type !== $scope.type){
					return;
				}

				$scope.closeEditor();
			});

			$scope.$on('sao:export', function(event, data){
				if($scope.type !== data.type){
					return;
				}

				$scope.saveFunc($scope.letters, $scope.company, data.callback);
			});

			$scope.openUrl = function () {
				let win = window.open("http://" + $scope.url, 'domainWindow',);
				win.opener.focus();
				$scope.domainIsOpen = true;
			};

			$scope.prev = function () {
				$rootScope.$broadcast('sao:editLetters:byIndex', {
					type: $scope.type,
					index: $scope.prevIndex
				});
			};

			$scope.next = function () {
				$rootScope.$broadcast('sao:editLetters:byIndex', {
					type: $scope.type,
					index: $scope.nextIndex
				});
			};

			$scope.save = function (andNext) {
				let callback = andNext ? function(){
					$scope.next();
				} : null;

				$scope.saveFunc($scope.letters, $scope.company, callback);
			};

			$scope.closeEditor = function(){
				$scope.letters = [];
				$scope.url = '';
				$scope.title = '';
				$scope.isOpen = false;
				$scope.collapsed = false;
				$scope.contactsOpen = false;

				$timeout(function(){
					jQuery('body').removeClass($scope.type + '-is-open');
				}, 0);

				$rootScope.$broadcast('sao:lettersEditorClosed', {type: $scope.type});
			};

			$scope.openContacts = function(){
				if($scope.contactsOpen){
					$rootScope.$broadcast('sao:closeContacts');
				} else {
					$rootScope.$broadcast('sao:openContacts', {
						company: $scope.company,
						list:    $scope.list,
					});
				}

				$scope.contactsOpen = !$scope.contactsOpen;
			};

			$scope.collapsed = false;
			$scope.contactsOpen = false;
		}
	}
}